import { EyeIcon, HStack, Text } from '@cdl/heartbeat-react';
import { Link } from 'react-router-dom';
import { AnnotationTask } from '../../../ecg/types/annotation-tasks.type';

type Props = {
  id: string;
  name?: string;
  annotationTask?: AnnotationTask;
};

export const TaskLinkColumn: React.FC<Props> = ({
  id,
  name,
  annotationTask,
}) => {
  return (
    <HStack>
      <Link to={`/admin/task_page/${id}`}>
        {name ? (
          <Text as='u' fontWeight='regular'>
            {name}
          </Text>
        ) : (
          <EyeIcon />
        )}
      </Link>
      {annotationTask &&
        new Date(annotationTask.createdAt).toDateString() ===
          new Date().toDateString() && (
          <Text fontWeight='semibold' color='primary.400'>
            [NEW]
          </Text>
        )}
    </HStack>
  );
};
